import Vue from 'vue'
import Vuei18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import mitt from 'mitt'
import PortalVue from 'portal-vue'
import './core'
import './requests'
import './tracking'
import './firebase'

Vue.use(Vuei18n)
Vue.use(Vuelidate)
Vue.use(PortalVue)

Vue.prototype.$event = mitt()

export const i18n = new Vuei18n({ })
export const availableLanguages = [
  'pt-BR'
]
